import React, { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";

const EmailVerificationPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userId, token } = useParams();
  console.log("UserID:", userId);
  console.log("Token:", token);
  
  const [status, setStatus] = useState("loading"); 
  const [message, setMessage] = useState("");
  const requestSentRef = useRef(false); // ref kullanarak render'lar arasında değerin korunmasını sağlıyoruz

  const API_URL = process.env.REACT_APP_API_URL;
  
  const verifyEmail = useCallback(async () => {
    // Eğer istek zaten gönderildiyse, tekrar gönderme
    if (requestSentRef.current) return;
    
    // İsteği işaretleme
    requestSentRef.current = true;
    
    try {
      if (!userId || !token) {
        setStatus("error");
        setMessage("Parameters required for validation are missing.");
        return;
      }

      const response = await axios.get(
        `${API_URL}/users/verify/${userId}/${token}`
      );

      if (response.data.success || response.data.message.includes("verified")) {
        setStatus("success");
        setMessage("Your email has been successfully verified!");
      } else {
        setStatus("error");
        setMessage(response.data.message || "Verification failed.");
      }
    } catch (error) {
      console.error("Email verification error:", error);
      setStatus("error");
      setMessage(
        error.response?.data?.message || 
        "An error occurred during verification. Please try again."
      );
    }
  }, [userId, token, API_URL]);

  useEffect(() => {
    verifyEmail();
  }, [verifyEmail]);

  useEffect(() => {
    if (status === "success") {
      setTimeout(() => {
        navigate("/signIn");
      }, 3000);
    }
  }, [status, navigate]);

  const handleGoToLogin = () => {
    navigate("/signIn");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h1 className="text-2xl font-poppins text-text text-center mb-6">
          {t("emailVerification")}
        </h1>
        
        {status === "loading" && (
          <div className="text-center py-4">
            <div className="w-16 h-16 border-4 border-text border-t-transparent rounded-full animate-spin mx-auto"></div>
            <p className="mt-4 text-text font-poppins">
              {t("verifyingEmail")}
            </p>
          </div>
        )}
        
        {status === "success" && (
          <div className="text-center py-4">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
              <svg
                className="w-8 h-8 text-green-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                ></path>
              </svg>
            </div>
            <p className="mt-4 text-text font-poppins">
              {message}
            </p>
            <button
              onClick={handleGoToLogin}
              className="w-full h-[61px] bg-text text-white py-2 rounded-full text-[20px] font-poppins mt-6"
            >
              {t("goToLogin")}
            </button>
          </div>
        )}
        
        {status === "error" && (
          <div className="text-center py-4">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto">
              <svg
                className="w-8 h-8 text-red-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </div>
            <p className="mt-4 text-red-500 font-poppins">
              {message}
            </p>
            <button
              onClick={handleGoToLogin}
              className="w-full h-[61px] bg-text text-white py-2 rounded-full text-[20px] font-poppins mt-6"
            >
              {t("goToLogin")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailVerificationPage;